export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-tablet-menu.vue?vue&type=template&id=ca86ba1c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-tablet-menu/lk-tablet-menu.vue?vue&type=template&id=ca86ba1c&
// module id = 1311
// module chunks = 0